import "../scss/style.scss";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);

  window.windowWidth = window.innerWidth;
  window.windowHeight = window.innerHeight;

  window.addEventListener("resize", function () {
    window.windowWidth = window.innerWidth;
    window.windowHeight = window.innerHeight;
  });

  let initWindowWidth = window.innerWidth;
  const appHeight = () => {
    let newWindowWidth = window.innerWidth;
    if (initWindowWidth != newWindowWidth) {
      vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    }

    initWindowWidth = newWindowWidth;
  };

  window.addEventListener("orientationchange", appHeight);
  window.addEventListener("resize", appHeight);

const REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

function buildMasterTimeline() {
  const master = gsap.timeline({ paused: true });
  const wrappers = gsap.utils.toArray(".bubble-wrapper");

  const preRoll = 0.1;   // tramo de entrada del contenedor
  const perBubble = 1; // tramo de scroll por burbuja

  // --- Pre-roll: el chat sube desde abajo del todo
  gsap.set(".chat-inner", { yPercent: 100, opacity: 1 });
  master.to(".chat-inner", { yPercent: 0, duration: preRoll, ease: "power3.out" }, 0);

  // Pequeña utilidad: decide el desplazamiento lateral según el lado
  const sideOffset = (wrapper) =>
    wrapper.classList.contains("from-me") ? 18 : -18; // px

  const thresholds = [];

  wrappers.forEach((wrapper, i) => {
    const bubble = wrapper.querySelector(".bubble");
    const textEl = wrapper.querySelector(".bubble__text");
    const tpl = wrapper.querySelector("template.bubble-template");
    const html = tpl ? tpl.innerHTML.trim() : (wrapper.dataset.text || "").trim();
    textEl.innerHTML = html;

    // Estados iniciales
    gsap.set(bubble, { opacity: 0 });
    wrapper.classList.add("loading");
    wrapper.classList.remove("loaded");

    const toLoading = () => {
      wrapper.classList.add("loading");
      wrapper.classList.remove("loaded");
    };
    const toLoaded = () => {
      wrapper.classList.remove("loading");
      wrapper.classList.add("loaded");
    };

    const loadingDur = 0.8, appearDur = 0.8;

    // Definir la animación de entrada:
    // - Primera burbuja: desde abajo + leve lateral según lado
    // - Resto: leve lateral (izq/der) + fade
    const fromVars =
      i === 0
        ? { opacity: 0, yPercent: 100, x: sideOffset(wrapper), maxHeight: 0}
        : { opacity: 0, x: sideOffset(wrapper), y: 8, maxHeight: 0 };
    const toVars =
      i === 0
        ? { opacity: 1, yPercent: 0, x: 0, duration: appearDur + 0.15, ease: "back.out(1.4)", maxHeight: 180}
        : { opacity: 1, x: 0, y: 0, duration: appearDur, ease: "power2.out", maxHeight: 180 };

    // Sub-timeline por burbuja
    const tl = gsap.timeline({ defaults: { ease: "none" } });

    // loading skeleton (si tu CSS lo define)
    tl.add(() => toLoading(), 0)
      .to({}, { duration: loadingDur });

    // loaded + entrada con fade + desplazamiento lateral
    tl.add(() => toLoaded())
      .fromTo(bubble, fromVars, toVars, 0);

    // Añadir al maestro
    master.add(tl, preRoll + i * perBubble);
    thresholds.push({ wrapper, startTime: preRoll + i * perBubble });
  });

  master._thresholds = thresholds;
  return master;
}

if (!REDUCED) {
  const master = buildMasterTimeline();

  ScrollTrigger.create({
    animation: master,
    trigger: ".chat",
    start: "top top",
    end: () => `+=${window.innerHeight * 3}`,
    pin: true,
    scrub: true,
    anticipatePin: 1,
    onUpdate: () => {
      // Control de visibilidad para que el bloque quede unido y pegado abajo
      const t = master.time();
      master._thresholds.forEach(({ wrapper, startTime }) => {
        if (t >= startTime) wrapper.classList.add("is-visible");
        else wrapper.classList.remove("is-visible");
      });
    },
  });

  // Por si cambias layout/tamaños
  ScrollTrigger.refresh();
} else {
  // Modo accesible: todo visible sin animaciones
  document.querySelectorAll(".bubble-wrapper").forEach((w) => {
    const textEl = w.querySelector(".bubble__text");
    const tpl = w.querySelector("template.bubble-template");
    textEl.innerHTML = tpl ? tpl.innerHTML : (w.dataset.text || "");
    w.classList.add("loaded", "is-visible");
    gsap.set(w.querySelector(".bubble"), { opacity: 1, x: 0, y: 0 });
  });
}
